import React from 'react';
//import styled from 'styled-components';
import { Page, PageContent, PageHeader, Footer, Text } from 'grommet';
//import { Hpe as HpeIcon } from 'grommet-icons';
import Iframe from 'react-iframe';
import { AppFooter } from '../components';

const SaaSPage = () => {

  //const [value, setValue] = React.useState('');
  //const size = useContext(ResponsiveContext);
  //const [focused] = useState(false);
  //const [focused, setFocused] = useState(false);

  return (

    <Page background="background-back" flex="grow">

      <PageContent height="100%">
        <PageHeader title="CrowdStrike Issue" size="small"
          pad={{ vertical: 'small' }}
          subtitle={`Please use the latest instructions below to recover your PC.`}
        />

        <Iframe url="https://hpe.com"
          width="100%"
          height="100%"
          border="0px"
          id=""
          className=""/>

      </PageContent>

      <Footer pad="xsmall" justify="center">
        <Text size="11pt" style={{fontStyle: 'italic', fontWeight: 'bold'}}>Powered by HPE IT</Text>
      </Footer>

      <AppFooter />

    </Page>

  );
};

export { SaaSPage as SaaS };